export default {
    APP_BUILDER_PREVIEW_APP_ID: '46b2ad43-5720-41d2-8436-2058979cb53f'
}
